/**
 * Created by shegj on 2018-05-20.
 * 全局常量 Constants
 */
"use strict";
const baseUrl = process.env.API_ROOT;
module.exports = {
  serverURL: "/honda",
  // serverURL: baseUrl, // "/honda",
  imgUrl: '/honda',
  pageCurrent: 1,       //分页信息-当前页
  pageSize: 10,         //分页信息-每页显示条数
  statusCode: {ok:200, error:300, timeout:301},//服务器返回状态吗
  examYear: [{id:1,year:2020,data:[]},{id:2,year:2019,data:[]},{id:3,year:2018,data:[]},{id:4,year:2017,data:[]},{id:5,year:2016,data:[]}],  //考试年份
  studyCourseFlag : -1,
};



// WEBPACK FOOTER //
// ./src/common/Constants.js